import { AxlesData } from './AxleInformationFields';

export const TrailerFieldNames = {
  TrailerId: 'trailerId',
  IsDualLane: 'isDualLane',
  IsTrunnionAxle: 'isTrunnionAxle',
  TrailerUnitNumber: 'trailerUnitNumber',
  TrailerYear: 'trailerYear',
  TrailerMake: 'trailerMake',
  TrailerVIN: 'trailerVIN',
  TrailerType: 'trailerType',
  TrailerAxleCount: 'trailerAxleCount',
  TrailerLicensePlate: 'trailerLicensePlate',
  TrailerLicensePlateState: 'trailerLicensePlateState',
  TrailerLicensePlateType: 'trailerLicensePlateType',
  TrailerLength: 'trailerLength',
  TrailerWidth: 'trailerWidth',
  TrailerHeight: 'trailerHeight',
  TrailerWheelbaseLength: 'trailerWheelbaseLength',
  TrailerDeckHeight: 'trailerDeckHeight',
  TrailerGroundClearance: 'trailerGroundClearance',
  TrailerKingpinSetbackLength: 'trailerKingpinSetbackLength',
  TrailerKingpinSettingLength: 'trailerKingpinSettingLength',
  TrailerEmptyWeight: 'trailerEmptyWeight',
  TrailerRegisteredWeight: 'trailerRegisteredWeight',
} as const;

export type TrailerData = {
  [TrailerFieldNames.TrailerId]?: string;
  [TrailerFieldNames.IsDualLane]?: boolean;
  [TrailerFieldNames.IsTrunnionAxle]?: boolean;
  [TrailerFieldNames.TrailerUnitNumber]?: string;
  [TrailerFieldNames.TrailerYear]?: number;
  [TrailerFieldNames.TrailerMake]?: string;
  [TrailerFieldNames.TrailerVIN]?: string;
  [TrailerFieldNames.TrailerType]?: string;
  [TrailerFieldNames.TrailerAxleCount]?: string;
  [TrailerFieldNames.TrailerLicensePlate]?: string;
  [TrailerFieldNames.TrailerLicensePlateState]?: string;
  [TrailerFieldNames.TrailerLicensePlateType]?: string;
  [TrailerFieldNames.TrailerLength]?: number | string;
  [TrailerFieldNames.TrailerWidth]?: number | string;
  [TrailerFieldNames.TrailerHeight]?: number | string;
  [TrailerFieldNames.TrailerWheelbaseLength]?: number | string;
  [TrailerFieldNames.TrailerDeckHeight]?: number | string;
  [TrailerFieldNames.TrailerGroundClearance]?: number | string;
  [TrailerFieldNames.TrailerKingpinSetbackLength]?: number | string;
  [TrailerFieldNames.TrailerKingpinSettingLength]?: number | string;
  [TrailerFieldNames.TrailerEmptyWeight]?: number;
  [TrailerFieldNames.TrailerRegisteredWeight]?: number;
} & AxlesData;

export type TrailerInformationFields = {
  trailers?: TrailerData[];
};

export const TrailerFields: string[] = Object.values(TrailerFieldNames);
